import { useInstanceKey } from 'app/area/favourite/favourite-context';
import { selectWorkingDefinition } from 'app/area/favourite/selectors';
import { selectionReportId } from 'app/area/reports/constants';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export function useShouldInitiallyOpenPanel() {
  const instanceKey = useInstanceKey();
  const workingDefinition = useSelector(selectWorkingDefinition(instanceKey));

  return useMemo(() => {
    const selectionReportDefinition = workingDefinition.reports.find(r => r.report.v === selectionReportId);
    return !!selectionReportDefinition && !selectionReportDefinition.aggregationDomain;
  }, []);
}
